import IntercomMessenger, {
  update,
  hide,
  show,
  shutdown,
} from '@intercom/messenger-js-sdk';

export default function Intercom(
  action: 'boot' | 'update' | 'hide' | 'show' | 'shutdown',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options?: any
) {
  if (action === 'boot') {
    IntercomMessenger(options);
  } else if (action === 'update') {
    update(options);
  } else if (action === 'hide') {
    hide();
  } else if (action === 'show') {
    show();
  } else if (action === 'shutdown') {
    shutdown();
  }
}
